// extracted by mini-css-extract-plugin
export default {"block":"InfoBlock_block__FvhDC","title":"InfoBlock_title__ad3IY","text":"InfoBlock_text__Q18oU"};